module.exports = __webpack_public_path__ + "static/media/move.ff057909.jpg";